export default function getDaysBetween(startDate) {
    const currentDate = new Date();
    const today = [
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        currentDate.getDate()
    ];
    const parsedStartDate = startDate.split("-").map(Number);

    let sDate, eDate;

    if (today[0] >= 1000) {
        sDate = new Date(`${today[0]}/${today[1]}/${today[2]}`);
    } else if (today[2] >= 1000) {
        sDate = new Date(`${today[2]}/${today[0]}/${today[1]}`);
    } else {
        return 0;
    }

    if (parsedStartDate[0] >= 1000) {
        eDate = new Date(`${parsedStartDate[0]}/${parsedStartDate[1]}/${parsedStartDate[2]}`);
    } else if (parsedStartDate[2] >= 1000) {
        eDate = new Date(`${parsedStartDate[2]}/${parsedStartDate[0]}/${parsedStartDate[1]}`);
    } else {
        return 0;
    }

    const oneDay = 1000 * 60 * 60 * 24;
    const daysApart = 4835 + Math.ceil((sDate.getTime() - eDate.getTime()) / oneDay);

    return `${daysApart} - ${today[2]}/${today[1]}/${today[0]}`;
}